import { render, staticRenderFns } from "./DocImageDetection.vue?vue&type=template&id=74528a46&scoped=true"
import script from "./DocImageDetection.vue?vue&type=script&lang=js"
export * from "./DocImageDetection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74528a46",
  null
  
)

export default component.exports